import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useUserStore } from './stores/user'

const app = createApp(App)

app.use(createPinia())

// 初始化用户状态
const userStore = useUserStore()
userStore.initFromStorage()

app.use(router)

// 懒加载Ant Design Vue
import('ant-design-vue').then((Antd) => {
  app.use(Antd.default)
  app.mount('#app')
})
